import * as Yup from "yup";
import { determ_is_dutch } from "./utils";

/* ---------------------------------- REGEX --------------------------------- */
const cocRegex = /^[0-9]{8}$/;
const datastoreNameRegex = /^[a-zA-Z0-9_-]+$/;
const dnsRegex =
	/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
const emailRegex =
	/^([a-zA-Z0-9_\-.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/;
const emailMultiRegex =
	/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})((?:, ?|; ?)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
const inputTextRegex = /^[A-Za-z\s'-_."0-9A-Za-zÀ-ÿà-ÿĀ-ſƀ-ɏḀ-ỿ][^<>]*$/;
const inputDomainRegex =
	/^([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?)(?:\.([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])?)*))?$/;

// Free text regex to accept all Latin characters
// For more information about Unicode ranges, see https://www.regular-expressions.info/unicode.html
// \u0000-\u024F: Range to accept all control characters (\u0000 to \u001F) and all ASCII, Extended ASCII, Extended Latin A and Extended Latin B characters (\u0020 to \u024F), spanning from index 0 to index 591.
// \u1E00-\u1EFF: Range to accept all Latin Extended Additional characters, spanning from index 7680 to index 7935. These are necessary for Eastern European languages.
// \u20AC-\u20CF: Range to accept all currency symbols, spanning from index 8364 to index 8423.
// biome-ignore lint/suspicious/noControlCharactersInRegex: Control characters are allowed (\u0000 to \u001F)
const inputFreeTextRegex = /^[\u0000-\u024F\u1E00-\u1EFF\u20AC-\u20CF]*$/;

const inputOtpRegex = /^[0-9]*$/;
const houseNumberRegex = /^[0-9]{0,9}$/;
const nameRegex = /^[A-Za-z0-9A-Za-zÀ-ÿà-ÿĀ-ſƀ-ɏḀ-ỿ\s,.\-']*$/;
const oxxaCompanyNameRegex = /^[a-zA-Z0-9\s&\-().']+$/;
const passwordRegex =
	/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+).{12,1024}$/;
const phoneNumberDigitsInputRegex = /^[0-9\s-]*$/;
const productNumberHostfactRegex = /^P[0-9]{3,6}$/;
const proxmoxHostRegex =
	/^(?:(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?))|(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){6})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:::(?:(?:[0-9a-fA-F]{1,4}):){5})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:[0-9a-fA-F]{1,4}))?::(?:(?:[0-9a-fA-F]{1,4}):){4})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,1}(?:[0-9a-fA-F]{1,4}))?::(?:(?:[0-9a-fA-F]{1,4}):){3})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,2}(?:[0-9a-fA-F]{1,4}))?::(?:(?:[0-9a-fA-F]{1,4}):){2})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,3}(?:[0-9a-fA-F]{1,4}))?::(?:(?:[0-9a-fA-F]{1,4}):){1})(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,4}(?:[0-9a-fA-F]{1,4}))?::)(?:(?:(?:(?:(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9])\.){3}(?:25[0-5]|(?:2[0-4]|1[0-9]|[1-9])?[0-9]))|(?:[0-9a-fA-F]{1,4}):(?:[0-9a-fA-F]{1,4}))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,5}(?:[0-9a-fA-F]{1,4}))?::)(?:[0-9a-fA-F]{1,4}))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4}):){0,6}(?:[0-9a-fA-F]{1,4}))?::)))))$/;
const proxmoxFingerprintRegex = /^(?:[0-9a-fA-F][0-9a-fA-F])(?::[0-9a-fA-F][0-9a-fA-F]){31}$/;
// biome-ignore lint/suspicious/noControlCharactersInRegex: See comment of 'input_free_text_regex'
const proxmoxUserNameRegex = /^([^\s:/\x00-\x1F\x7F]+@[A-Za-z0-9_][A-Za-z0-9._-]*)/;
const proxmoxTokenNameRegex = /^(?:[A-Za-z0-9_][A-Za-z0-9._-]*)$/;
const proxmoxRegexInputText = /^(?:[A-Za-z0-9_][A-Za-z0-9._-]*)$/;
// biome-ignore lint/suspicious/noControlCharactersInRegex: See comment of 'input_free_text_regex'
const proxmoxRegexInputTextFree = /^[^\x00-\x1F\x7F]*$/;
const snapshotRegex = /^(?!.*portal)[A-Za-z0-9_-]*$/;
const tldRegex =
	/^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])?)*$/;
const usernameRegex = /^[A-Za-zÀ-ÿà-ÿĀ-ſƀ-ɏḀ-ỿ0-9_-]{3,50}$/;
const usernameDebtorIncludedRegex = /^[A-Za-zÀ-ÿà-ÿĀ-ſƀ-ɏḀ-ỿ0-9_@-]{4,60}$/;
const vatNumberInternationalRegex =
	/^[A-Za-z\s'-_.,"/&0-9A-ZÀ-ÿà-ÿĀ-ſƀ-ɏḀ-ỿА-Яа-яЁёҐґЄєІіЇї!@%$&#^*]*$/;
const vatNumberEuRegex = /^[A-Z]{2}?[0-9A-Za-z./-]{2,12}$/;
const vatNumberDutchRegex = /^(NL)?[0-9]{9}B[0-9]{2}$/;
const zipCodeRegex = /^[a-zA-Z0-9\s-]*$/;
const zipCodeDutchRegex = /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/;

export const ibanRegex =
	/^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/;
export const cnameRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;
export const ipv4Regex = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;
export const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;
export const mxRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;
export const sshPublicKeyRegex = /^[0-9a-z-@.]+ [0-9A-Za-z+/=]+(?: .*)?$/;
export const txtRegex = /^"[^"]*"$/;
export const nsRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;
export const dadupBucketRegex = /^[a-zA-Z0-9]+$/;
export const dadupDisplayNameRegex = /^[a-zA-Z0-9][a-zA-Z0-9\s_-]+$/;

/* ---------------------------- DEFAULT MESSAGES ---------------------------- */
const booleanRequiredTrueInvalid = (t) => t("validation.boolean_required_true.invalid");
const cocInvalid = (t) => t("validation.coc.invalid");
const dnsInvalid = (t) => t("validation.dns.invalid");
const datastoreNameInvalid = (t) => t("validation.datastore_name.invalid");
const emailInvalid = (t) => t("validation.email.invalid");
const houseNumberInvalid = (t) => t("validation.house_number.invalid");
const inputOtpInvalid = (t) => t("validation.otp.only_numbers");
const inputTextInvalid = (t) => t("validation.input_text.invalid");
const inputFreeTextInvalid = (t) => t("validation.input_free_text.invalid");
const inputSelectInvalid = (t) => t("validation.input_select.invalid");
const inputNumberInvalid = (t) => t("validation.input_number.only_numbers");
const maxLength = (t, length) =>
	t("validation.input_text.max_length").replace("{{length}}", length);
const maxLengthNumber = (t, length) =>
	t("validation.input_number.max_length").replace("{{length}}", length);
const minLength = (t, length) =>
	t("validation.input_text.min_length").replace("{{length}}", length);
const minLengthNumber = (t, length) =>
	t("validation.input_number.min_length").replace("{{length}}", length);
const dateOfBirthTooRecent = (t) => t("validation.date_of_birth.too_recent");
const nameInvalid = (t) => t("validation.name.invalid");
const oxxaCompanyNameInvalid = (t) => t("validation.oxxa_company_name.invalid");
const passwordInvalid = (t) => t("validation.password.to_weak");
const phoneNumberDigitsInvalid = (t) => t("validation.phone.invalid");
const phoneNumberDigitsTooFewDigits = (t, length) =>
	t("validation.phone.too_few_phone_number_digits").replace("{{length}}", length);
const phoneNumberDigitsTooManyDigits = (t, length) =>
	t("validation.phone.too_many_phone_number_digits").replace("{{length}}", length);
const productNumberHostfactInvalid = (t) => t("validation.product_number_hostfact_invalid.invalid");
const required = (t) => t("validation.required");
const snapshotInvalid = (t) => t("validation.snapshot.invalid");
const sshPublicKeyInvalid = (t) => t("validation.ssh_public_key.invalid");
const tldInvalid = (t) => t("validation.tld.invalid");
const usernameInvalid = (t) => t("validation.username.invalid");
const vatInvalid = (t) => t("validation.vat_number.invalid");
const zipInvalid = (t) => t("validation.zip_code.invalid");
const domainInvalid = (t) => t("validation.domain.invalid");
const dadupDisplayNameInvalid = (t) => t("validation.dadup.invalid_display_name");
const dadupBucketIdInvalid = (t) => t("validation.dadup.invalid_bucket_name");

/* ----------------------------- BASE VARIABLES ----------------------------- */
const yupBoolean = Yup.boolean();
const yupDate = Yup.date();
const yupNumber = Yup.number().transform((_, v) => {
	if (!v) {
		return v;
	}
	// Replace the comma decimal separator with a dot
	const str = `${v}`.replace(",", ".");
	// Only proceed if the string matches a valid number pattern
	return /^-?[0-9]*\.?[0-9]+$/.test(str) ? Number.parseFloat(str) : Number.NaN;
});
const yupString = Yup.string();
const yupAny = Yup.mixed().nullable();

// COC NUMBER DUTCH
export const cocNumberOptional = (t) => yupString.matches(cocRegex, cocInvalid(t));
export const cocNumber = (t) => cocNumberOptional(t).required(required(t));

// DATASTORE NAME INVALID
export const datastoreName = (t, min, max) =>
	yupString
		.matches(datastoreNameRegex, datastoreNameInvalid(t))
		.min(min, minLength(t, min))
		.max(max, maxLength(t, max))
		.required(required(t));

// DATE OF BIRTH
export const dateOfBirthOptional = (t) =>
	yupDate.nullable().test("is-old-enough", dateOfBirthTooRecent(t), (v) => dateIsAtLeast6Yo(v));
export const dateOfBirth = (t) => dateOfBirthOptional(t).required(required(t));
export const dateOptional = () => yupDate.nullable();
export const date = (t) => dateOptional().required(required(t));

// DNS
export const dns = (t, min, max) =>
	yupString
		.min(min, minLength(t, min))
		.max(max, maxLength(t, max))
		.matches(dnsRegex, dnsInvalid(t))
		.required(required(t));

// EMAIL ADDRESS
export const emailAddressOptional = (t) =>
	yupString.matches(emailRegex, emailInvalid(t)).max(50, maxLength(t, 50));
export const emailAddress = (t) => emailAddressOptional(t).required(required(t));

// EMAIL ADDRESS MULTIPLE
export const emailAddressMultipleOptional = (t) =>
	yupString.matches(emailMultiRegex, emailInvalid(t)).max(255, maxLength(t, 255)).nullable();
export const emailAddressMultiple = (t) => emailAddressMultipleOptional(t).required(required(t));

// BOOLEAN
export const inputBoolean = (t) => yupBoolean.required(required(t));
export const inputBooleanRequiredTrue = (t) =>
	yupBoolean.required(required(t)).oneOf([true], booleanRequiredTrueInvalid(t));

// NUMBER
export const inputNumberOptional = (t, min, max) =>
	yupNumber
		.typeError(inputNumberInvalid(t))
		.nullable()
		.min(min, minLengthNumber(t, min))
		.max(max, maxLengthNumber(t, max));
export const inputNumber = (t, min, max) => inputNumberOptional(t, min, max).required(required(t));

// SELECT
export const inputSelect = (t, values) => yupString.oneOf(values, inputSelectInvalid(t));

// TEXT
export const inputTextOptional = (t, min, max) =>
	yupString
		.min(min, minLength(t, min))
		.max(max, maxLength(t, max))
		.matches(inputTextRegex, inputTextInvalid(t))
		.nullable();
export const inputText = (t, min, max) => inputTextOptional(t, min, max).required(required(t));
export const inputTextOnlyNumbersOptional = (t, min, max) =>
	inputTextOptional(t, min, max).matches(/^[0-9]+$/, inputNumberInvalid(t));
export const inputTextOnlyNumbers = (t, min, max) =>
	inputTextOnlyNumbersOptional(t, min, max).required(required(t));

export const inputFreeTextOptional = (t, min, max) =>
	yupString
		.min(min, minLength(t, min))
		.max(max, maxLength(t, max))
		.matches(inputFreeTextRegex, inputFreeTextInvalid(t))
		.nullable();
export const inputFreeText = (t, min, max) =>
	inputFreeTextOptional(t, min, max).required(required(t));

// OTP
export const inputOtp = (t) =>
	yupString
		.min(6, minLength(t, 6))
		.max(6, maxLength(t, 6))
		.matches(inputOtpRegex, inputOtpInvalid(t))
		.required(required(t));

// DOMAIN
export const inputDomain = (t) => yupString.matches(inputDomainRegex, domainInvalid(t));

export const inputOxxaCompanyNameOptional = (t) =>
	yupString
		.min(2, minLength(t, 2))
		.max(100, maxLength(t, 100))
		.matches(oxxaCompanyNameRegex, oxxaCompanyNameInvalid(t));
export const inputOxxaCompanyName = (t) => inputOxxaCompanyNameOptional(t).required(required(t));

// HOUSE NUMBER
export const inputHouseNumberOptional = (t) =>
	yupString.matches(houseNumberRegex, houseNumberInvalid(t)).nullable();
export const inputHouseNumber = (t) => inputHouseNumberOptional(t).required(required(t));

// NAME
export const inputNameOptional = (t) =>
	yupString.max(100, maxLength(t, 100)).matches(nameRegex, nameInvalid(t)).nullable();
export const inputName = (t) => inputNameOptional(t).min(2, minLength(t, 2)).required(required(t));

// PASSWORD
export const inputPasswordNoRegexCheck = (t) =>
	yupString.min(1, minLength(t, 1)).max(1024, maxLength(t, 1024)).required(required(t));
export const inputPassword = (t) =>
	inputPasswordNoRegexCheck(t).min(12, minLength(t, 12)).matches(passwordRegex, passwordInvalid(t));

// REQUIRED
export const inputRequired = (t) => yupAny.required(required(t));

// USERNAME
export const inputUsername = (t) =>
	yupString
		.min(3, minLength(t, 3))
		.max(50, maxLength(t, 50))
		.matches(usernameRegex, usernameInvalid(t))
		.required(required(t));
export const inputUsernameDebtorIncluded = (t) =>
	yupString
		.min(4, minLength(t, 4))
		.max(60, maxLength(t, 60))
		.matches(usernameDebtorIncludedRegex, usernameInvalid(t))
		.required(required(t));

// PHONE NUMBER
export const phoneNumberDigitsOptional = (t) =>
	yupString
		.matches(phoneNumberDigitsInputRegex, phoneNumberDigitsInvalid(t))
		.test("min-7-phone-number-digits", phoneNumberDigitsTooFewDigits(t, 7), (value) => {
			if (!value) {
				return true;
			}
			const digitCount = value.replace(/[^0-9]/g, "").length;
			return digitCount >= 7;
		})
		.test("max-15-phone-number-digits", phoneNumberDigitsTooManyDigits(t, 15), (value) => {
			if (!value) {
				return true;
			}
			const digitCount = value.replace(/[^0-9]/g, "").length;
			return digitCount <= 15;
		});
export const phoneNumberDigits = (t) => phoneNumberDigitsOptional(t).required(required(t));

// PRODUCT_NUMBER_HOSTFACT
export const productNumberHostfactOptional = (t) =>
	yupString
		.min(4, minLength(t, 4))
		.max(10, maxLength(t, 10))
		.matches(productNumberHostfactRegex, productNumberHostfactInvalid(t))
		.nullable();
export const productNumberHostfact = (t) => productNumberHostfactOptional(t).required(required(t));

// PROXMOX REGEX HOST
export const proxmoxHost = (t) =>
	yupString.matches(proxmoxHostRegex, t("validation.proxmox_host.invalid")).required(required(t));
export const proxmoxFingerprint = (t) =>
	yupString
		.matches(proxmoxFingerprintRegex, t("validation.proxmox_fingerprint.invalid"))
		.required(required(t));
export const proxmoxUserName = (t) =>
	yupString
		.matches(proxmoxUserNameRegex, t("validation.proxmox_user_name.invalid"))
		.required(required(t));
export const proxmoxTokenName = (t) =>
	yupString
		.matches(proxmoxTokenNameRegex, t("validation.proxmox_token_name.invalid"))
		.required(required(t));

export const proxmoxInputText = (t) =>
	yupString
		.matches(proxmoxRegexInputText, t, t("validation.proxmox_regex.invalid"))
		.required(required(t));

export const proxmoxInputTextFree = (t) =>
	yupString
		.matches(proxmoxRegexInputTextFree, t("validation.proxmox_regex_free.invalid"))
		.required(required(t));
export const proxmoxSchedule = (t) =>
	yupString.notOneOf(["none"], required(t)).required(required(t));

// SNAPSHOT
export const snapshot = (t) =>
	yupString
		.min(4, minLength(t, 4))
		.max(40, maxLength(t, 40))
		.matches(snapshotRegex, snapshotInvalid(t))
		.required(required(t));

// SSH PUBLIC KEY
export const sshPublicKey = (t) =>
	yupString.matches(sshPublicKeyRegex, sshPublicKeyInvalid(t)).required(required(t));

// TLD
export const tld = (t, min, max) =>
	yupString
		.matches(tldRegex, tldInvalid(t))
		.min(min, minLength(t, min))
		.max(max, maxLength(t, max))
		.required(required(t));

// VAT NUMBER DUTCH
export const vatNumberDutch = (t) => yupString.matches(vatNumberDutchRegex, vatInvalid(t));

// VAT NUMBER EU
export const vatNumberEu = (t) =>
	yupString.matches(vatNumberEuRegex, vatInvalid(t)).required(required(t));

// VAT NUMBER INTERNATIONAL
export const vatNumberInternational = (t) =>
	yupString.matches(vatNumberInternationalRegex, vatInvalid(t));

// ZIP CODE
export const zipCode = (t) =>
	yupString
		.min(2, minLength(t, 2))
		.max(10, maxLength(t, 10))
		.matches(zipCodeRegex, zipInvalid(t))
		.required(required(t));

// ZIP CODE DUTCH
export const zipCodeDutch = (t) =>
	yupString
		.min(2, minLength(t, 2))
		.max(10, maxLength(t, 10))
		.matches(zipCodeDutchRegex, zipInvalid(t))
		.required(required(t));

// DADUP
export const dadupDisplayName = (t) =>
	yupString
		.matches(dadupDisplayNameRegex, dadupDisplayNameInvalid(t))
		.min(3, minLength(t, 3))
		.max(50, maxLength(t, 50))
		.required(required(t));

export const dadupBucketId = (t) =>
	yupString
		.matches(dadupBucketRegex, dadupBucketIdInvalid(t))
		.min(3, minLength(t, 3))
		.max(63, maxLength(t, 63))
		.required(required(t));

/* -------------------------------------------------------------------------- */
/*                        COMPLEX VALIDATION FUNCTIONS                        */
/* -------------------------------------------------------------------------- */
export const determCocNumberValidation = (t, optional = false) => {
	return Yup.string().when("country_code", {
		is: (countryCode) => determ_is_dutch(countryCode),
		otherwise: () => Yup.string(),
		then: () => (optional ? cocNumberOptional(t) : cocNumber(t)),
	});
};

export const determVatNumberValidation = (t, isRequired = false, isViesRequired = false) => {
	const determRequired = (validator) => {
		if (!isRequired) {
			return validator;
		}
		return validator.required(required(t));
	};

	const dutchValidator = () => {
		return determRequired(vatNumberDutch(t));
	};
	const defaultValidator = () => {
		if (isViesRequired) {
			return determRequired(vatNumberEu(t));
		}

		return determRequired(vatNumberInternational(t));
	};

	return Yup.string().when("country_code", {
		is: (countryCode) => determ_is_dutch(countryCode),
		otherwise: defaultValidator,
		then: dutchValidator,
	});
};

/* -------------------------------------------------------------------------- */
/*                                TEST HELPERS                                */
/* -------------------------------------------------------------------------- */
const dateIsAtLeast6Yo = (date) => {
	if (date === "" || date === undefined) {
		return true;
	}

	const currentDate = new Date();
	const sixYearsAgo = new Date(
		currentDate.getFullYear() - 6,
		currentDate.getMonth(),
		currentDate.getDate(),
	);

	return new Date(date) <= sixYearsAgo;
};
